const localizationInterpolation = { prefix: "{{", suffix: "}}" };
export {
  localizationInterpolation as l
};
//# sourceMappingURL=localization.js.map
